<template>
  <div class="animated fadeIn">
    <b-row v-if="!hideAllFilters">
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hideDate="filterDisplay.hideDate"
                :allowAllCompanies="false"
              ></Filters>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-button variant="success" v-on:click="goTo('/admin/regions/add')"
            ><i class="fa fa-plus"></i> Add New Region</b-button
          >
        </b-card>
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Regions
          </div>
          <div v-if="!tableReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="tableReady">
            <div v-if="!items.length">
              <b-alert show variant="warning">
                No Regions
              </b-alert>
            </div>
            <table class="table table-striped" v-if="items.length">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Company</th>
                  <th>Landing Page</th>
                  <th>Date Added</th>
                  <th>Date Updated</th>
                  <th class="action-single"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <router-link
                      :to="{ name: 'Update Region', params: { id: item._id } }"
                      >{{ item.name }}</router-link
                    >
                  </td>
                  <td>{{ item.company.name }}</td>
                  <td>{{ item.landingPage | formatSlug }}</td>
                  <td>{{ item.dateAdded | formatDate }}</td>
                  <td>{{ item.dateUpdated | formatDate }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-danger"
                      @click="deleteItem(item)"
                    >
                      <i class="fa fa-remove"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col> </b-row
    ><!--/.row-->
    <b-modal
      title="Confirm Delete"
      class="modal-danger"
      v-model="deleteModal"
      @ok="confirmDelete()"
      ok-variant="danger"
    >
      <div><b>Are you sure you want to delete this region?</b></div>
      <div>{{ selectedItem.name }}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import common from "./../../../mixins/common";
import filter from "./../../../mixins/filter";
import Filters from "@/views/common/Filters";

export default {
  name: "regions",
  data() {
    return {
      selectedItem: {},
      items: [],
      deleteModal: false,
      tableReady: false
    };
  },
  mixins: [common, filter],
  components: {
    Filters
  },
  methods: {
    apply() {
      this.getItems();
    },
    getItems: function() {
      let scope = this;
      scope.tableReady = false;
      let where =
        "&where=" +
        JSON.stringify({
          company: scope.filters.company
        });
      scope.$store.dispatch("getRegions", where).then(
        result => {
          scope.items = result;
          scope.tableReady = true;
        },
        error => {
          console.log(error);
        }
      );
    },
    deleteItem: function(selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function() {
      this.deleteModal = false;
      let scope = this;
      axios
        .delete(process.env.VUE_APP_API + "/region/" + scope.selectedItem._id, {
          headers: {
            Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
          }
        })
        .then(function(response) {
          scope.getItems();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  created() {
    this.setupFilter();
    this.getItems();
  }
};
</script>
